// extracted by mini-css-extract-plugin
module.exports = {"depositEarn":"token-splash_depositEarn__dTXi4","emptyBox":"token-splash_emptyBox__ZR4_H","noData":"token-splash_noData__mPWwu","h5landing":"token-splash_h5landing__uxKGG"};